export const QUEUE_ACTION_GET_AVAILABILITIES = 'QUEUE_ACTION_GET_AVAILABILITIES'
export const QUEUE_ACTION_SET_AVAILABILITY = 'QUEUE_ACTION_SET_AVAILABILITY'
export const QUEUE_SET_FETCHING_AVAILABILITIES = 'QUEUE_SET_FETCHING_AVAILABILITIES'
export const QUEUE_SET_AVAILABILITIES = 'QUEUE_SET_AVAILABILITIES'
export const QUEUE_RECEIVE_AVAILABILITY_UPDATE = 'QUEUE_RECEIVE_AVAILABILITY_UPDATE'

export const QUEUE_ACTION_GET_QUEUES = 'QUEUE_ACTION_GET_QUEUES'
export const QUEUE_SET_FETCHING_QUEUES = 'QUEUE_SET_FETCHING_QUEUES'
export const QUEUE_SET_QUEUES = 'QUEUE_SET_QUEUES'